import { ConfirmableFieldAlias } from "@/models/field-confirmation-interface";
import { InputByTypeProperties } from "@/models/form-builder-interface";

export type UserLoginConfirmBy = ConfirmableFieldAlias | 'customLogin' | 'accountId';

export interface UserLoginProps {
  id?: string;
  inputProperties?: InputByTypeProperties;
  passwordConfirmBy?: UserLoginConfirmBy;
  onLogin?: (accountId?: number) => void;
}

export const defaults =
{
  passwordConfirmBy: 'email' as const,
};
